import { GlobeHemisphereWest } from "@phosphor-icons/react";
import { Container } from "./Section";

export default function International({ t }) {
  return (
    <section id="international" className="py-20 lg:py-24 bg-white border-y border-[#E2E8F0]">
      <Container className="grid lg:grid-cols-12 gap-8 lg:gap-16 items-start">
        <div className="lg:col-span-5 flex items-center gap-5">
          <GlobeHemisphereWest size={34} weight="light" className="text-[#0B1B3D] shrink-0" />
          <h2 className="font-heading text-2xl md:text-3xl font-semibold tracking-tight text-[#0B1B3D]" data-testid="international-title">
            {t.international.title}
          </h2>
        </div>
        <p className="lg:col-span-7 text-base md:text-lg leading-relaxed text-[#5A6B7C]" data-testid="international-text">
          {t.international.text}
        </p>
      </Container>
    </section>
  );
}
